
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1650505688351",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "5802",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M959.3 834.7v-677c0-50.7-41.1-91.9-91.9-91.9h-677c-50.7 0-91.9 41.1-91.9 91.9V676l266.9-286.2c3.6-3.9 8.7-6.2 14.2-5.9 5.4 0.1 10.4 2.6 13.9 6.7l172.6 207.1 197.8-243.5-63.6 10.6c-10.3 1.7-19.8-5.2-21.6-15.3-1.7-10.2 5.2-19.8 15.3-21.6l112.3-18.7c5.5-0.9 11 0.6 15.1 4.1 1.9 1.6 3.4 3.5 4.5 5.6 0 0 0 0.1 0.1 0.1 0.2 0.4 0.4 0.9 0.6 1.3 0.1 0.3 0.2 0.5 0.3 0.8 0.1 0.3 0.2 0.5 0.3 0.8 0.7 2.2 1 4.6 0.9 6.9V440c0.1 10.4-8.3 18.7-18.7 18.7s-18.7-8.4-18.7-18.7v-59.5L580.8 639c-3.5 4.4-8.8 6.8-14.4 6.9h-0.1c-5.6 0-10.8-2.5-14.4-6.7L378.4 431 98.5 731v103.7c0 50.7 41.1 91.9 91.9 91.9h677c50.7 0 91.9-41.2 91.9-91.9z",
        "p-id": "5803",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  